import styled from 'styled-components';
export const StyledBroadsiderInventory = styled.div`
  z-index: 101;
  position: relative;
  width: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  -webkit-backdrop-filter: blur(10px);
  -moz-backdrop-filter: blur(10px);
  -ms-backdrop-filter: blur(10px);
  -o-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  height: calc(100vh - ${({ theme }) => theme.frameOffset} - ${({ theme }) => theme.navHeight} - ${({ theme }) => theme.promoScrollerHeight} + ${({ theme }) => theme.frameWidth});
  height: 100%;

  .broadsider-inv-content-wrapper {
    width: 100%;
    height: 100%;
  }

  .broadsider-inv-content {
    width: 100%;
    height: 100%;
    border: 2px solid rgba(0, 0, 0, 0.36);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
    padding: 32px 0px 24px 0px;

    @media (max-height: 600px) {
      padding: 16px 0px 8px 0px;
    } 
  }

  .broadsider-inv-holder {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    gap: 16px;
    height: 100%;
    @media (max-height: 600px) {
      gap: 8px;
    } 
  }

  .broadsider-inv-title-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;

    @media (max-height: 600px) {
      padding: 0 16px;
    } 
  }

  .broadsider-inv-slot {
    width: 100%;
    position: relative;
    overflow: hidden;
    padding-left: 32px;
    padding-right: 32px;

    &:hover {
      .broadsider-inv-slot-decorator {
        transform: translateX(-8px);
      }

      .broadsider-inv-slot-decorator-selected {
        transform: translateX(0px);
      }
    }
  }
  
  .broadsider-inv-slot-delete-button {
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    font-weight: 800;
    font-size: 2rem;
    font-family: BebasNeue;
    padding-top: 6px;
    cursor: pointer;

    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: transparent;
    transition: 0.2s linear;
    &:hover {
      background: ${({ theme }) => theme.baseRed};
    }
  }

  .broadsider-inv-slot-decorator {
    position: absolute;
    height: 100%;
    width: 24px;
    background: white;
    transform: translateX(-24px);
    transition: linear 0.2s;
    top: 0;
    left: 0;
    bottom: 0;
  }

  .broadsider-inv-slot-decorator-back {
    position: absolute;
    height: 100%;
    width: 24px;
    background: ${({ theme }) => theme.selection};
    transform: translateX(24px);
    transition: linear 0.2s;
    top: 0;
    right: 0;
    bottom: 0;
  }

  .broadsider-inv-slot-decorator-selected {
    transform: translateX(0px);
    background: ${({ theme }) => theme.selection};
  }

  .broadsider-inv-logo {
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
  }

  .broadsider-inv-title {
    font-family: "NeueMachina";
    font-size: 1.5em;
    line-height: 1.2;
    font-weight: 800;
    color: white;
    text-transform: uppercase;
  }

  .broadsider-inv-cube {
    padding: 2px;
  }

  .broadsider-inv-cube-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
  }

  .broadsider-inv-cube-col {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .selection {
      background: ${({ theme }) => theme.selection};
    }

    div {
      background: ${({ theme }) => theme.frame};
      width: 8px;
      height: 8px;
    }
  }

  .broadsider-inv-items {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 16px;
    overflow-y: auto;

    @media (max-height: 600px) {
      gap: 8px;
    } 
  }

  

  .broadsider-inv-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .broadsider-inv-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .broadsider-inv-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .broadsider-inv-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .broadsider-inv-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }
`;
